<div class="block surface-panel md:w-full" style="max-width: 90vw">
  <p-tabView>
    <p-tabPanel>
      <ng-template pTemplate="header">
        <span class="text-800">Active Issues</span>
      </ng-template>

      <app-active-issues-list></app-active-issues-list>
    </p-tabPanel>

    <p-tabPanel>
      <ng-template pTemplate="header">
        <span class="text-800">Service Reminders</span>
      </ng-template>

      <div class="mt-4">
        <app-service-reminder></app-service-reminder>
      </div>
    </p-tabPanel>

    <p-tabPanel>
      <ng-template pTemplate="header">
        <span class="text-800">Signed Off Issues</span>
      </ng-template>

      <app-signed-off-issues-list></app-signed-off-issues-list>
    </p-tabPanel>
  </p-tabView>
</div>
